import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrWithdrawalMethod.ts
var t = () => e("withdrawalMethod");
//#endregion
export { t as useTrWithdrawalMethod };
